var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18283 9.02646C1.76951 9.02758 1.36496 9.14165 1.01598 9.35549C0.667011 9.56933 0.387876 9.8742 0.210874 10.2348C0.0338722 10.5954 -0.0337641 10.9971 0.0157905 11.3932C0.0653451 11.7894 0.230065 12.164 0.490894 12.4735L6.05116 19.0497C6.24941 19.2874 6.50353 19.4759 6.79243 19.5998C7.08132 19.7236 7.39664 19.779 7.71219 19.7616C8.38709 19.7266 8.9964 19.378 9.38488 18.8049L20.935 0.845592C20.9368 0.842613 20.9388 0.839634 20.9409 0.836699C21.0492 0.676045 21.0141 0.357672 20.7904 0.157665C20.7289 0.102741 20.6565 0.0605442 20.5775 0.0336731C20.4985 0.00680186 20.4147 -0.00417464 20.3312 0.00141981C20.2476 0.00701426 20.1662 0.0290612 20.0918 0.0662026C20.0174 0.103344 19.9517 0.154794 19.8987 0.217383C19.8945 0.222304 19.8903 0.22715 19.8859 0.231923L8.23745 12.9386C8.19313 12.9869 8.1393 13.0263 8.07908 13.0544C8.01886 13.0825 7.95347 13.0988 7.88669 13.1023C7.8199 13.1057 7.75307 13.0964 7.69007 13.0747C7.62706 13.0531 7.56915 13.0195 7.51968 12.9761L3.65379 9.57952C3.25229 9.22417 2.72751 9.02686 2.18283 9.02646Z",
    fill: "url(#paint0_linear_740_12212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_12212",
    x1: 4.85873,
    y1: 11.1748,
    x2: 20.8491,
    y2: 11.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.45787b0ac8c4e94062e1a5afb4a84140.svg";
export { ForwardRef as ReactComponent };